import React, { Fragment } from 'react';
import makeAnimated from 'react-select/animated';
import CreatableSelect from 'react-select/creatable';

const animatedComponents = makeAnimated();

const FromCreatableSelect = (props) => {
    const { label, options, handleMultiSelectChange, prefixes, error, disabled } = props;

    const customStyles = {
        control: (provided) => ({
            ...provided,
            border: error ? '1px solid red' : provided.border,
        }),
    };

    return (
        <Fragment>
            <label className="text-uppercase">{label}</label>
            <CreatableSelect
                components={animatedComponents}
                options={options}
                onChange={(value) => handleMultiSelectChange(value)}
                styles={customStyles}
                defaultValue={prefixes}
                isOptionDisabled={(option) => option.disabled}
                isMulti
                isDisabled={disabled}
            />
            {error && <small className="text-danger">{error}</small>}
        </Fragment>
    );
};

export default FromCreatableSelect;
